require('./bootstrap');

(function($) {
    "use strict";

    // Enable Bootstrap tooltips via data-attributes globally
    $('[data-toggle="tooltip"]').tooltip();

    // Enable Bootstrap popovers via data-attributes globally
    $('[data-toggle="popover"]').popover();

    $(".popover-dismiss").popover({
      trigger: "focus"
    });

    // Toggle the side navigation
    $("#sidebarToggle").on("click", function(e) {
      e.preventDefault();
      $("body").toggleClass("sidenav-toggled");
    });

    // Click to collapse responsive sidebar
    $("#layoutSidenav_content").click(function() {
      const BOOTSTRAP_LG_WIDTH = 992;
      if (window.innerWidth >= 992) {
        return;
      }
      if ($("body").hasClass("sidenav-toggled")) {
          $("body").toggleClass("sidenav-toggled");
      }
    });

    var hash = window.location.hash;
    // check localstorage for flash.tab
    if (localStorage.getItem("flash.tab")) {
        hash = localStorage.getItem("flash.tab");
        localStorage.removeItem("flash.tab");
    }

    hash && $('ul.nav a[href="' + hash + '"]').tab('show');

    $('.nav-item a').on('click', function (e) {
        $(this).tab('show');
        localStorage.setItem("flash.tab", $(this).attr('href'));
        var scrollmem = $('body').scrollTop();
        window.location.hash = this.hash;
        $('html,body').scrollTop(scrollmem);
    });

})(jQuery);
